class IngredientsSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.init = this.init.bind(this);
    this.destroy = this.destroy.bind(this);
  }

  connectedCallback() {
    this.init();
    window.addEventListener('resize', this.handleResize.bind(this));
    document.addEventListener('shopify:section:load', this.onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this.onSectionUnload.bind(this));
  }

  disconnectedCallback() {
    this.destroy();
    window.removeEventListener('resize', this.handleResize.bind(this));
    document.removeEventListener('shopify:section:load', this.onSectionLoad.bind(this));
    document.removeEventListener('shopify:section:unload', this.onSectionUnload.bind(this));
  }

  shouldEnableSwiper() {
    const slidesCount = this.querySelectorAll('#ingredients-mobile-swiper .swiper-slide').length;
    return slidesCount > 3;
  }

  init() {
    if (window.Swiper) {
      const swiperContainer = this.querySelector('#ingredients-mobile-swiper');
      if (swiperContainer && !swiperContainer.classList.contains('swiper-initialized')) {
        const slidesCount = this.querySelectorAll('#ingredients-mobile-swiper .swiper-slide').length;
        const shouldShowNavigation = slidesCount > 3;

        this.swiper = new Swiper(swiperContainer, {
          slidesPerView: 3,
          spaceBetween: 16,
          centeredSlides: false,
          loop: this.shouldEnableSwiper(),
          autoplay: this.shouldEnableSwiper() ? {
            delay: 4000,
            disableOnInteraction: false,
          } : false,
          navigation: shouldShowNavigation ? {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          } : false,
          breakpoints: {
            480: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            }
          },
          watchOverflow: true,
          initialSlide: 0,
          on: {
            init: () => {
              const navButtons = this.querySelectorAll('.swiper-button-prev, .swiper-button-next');
              navButtons.forEach(btn => {
                if (!shouldShowNavigation) {
                  btn.style.display = 'none';
                } else {
                  btn.style.display = 'flex';
                }
              });
            }
          }
        });
      }
    }
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  handleResize() {
    this.destroy();
    this.init();
  }

  onSectionLoad(e) {
    this.destroy();
    this.init();
  }

  onSectionUnload(e) {
    this.destroy();
  }
}

customElements.define('ingredients-slider', IngredientsSlider);

